---
meta:
  - title: Comprar paquetes adicionales - IUSPRO Docs
  - description: Aprende a comprar paquetes adicionales cuando se agotan tus créditos.
---

# Comprar paquetes adicionales

<a href="/settings/profile" target="_blank">
	Ir a Mi Perfil →
</a>

Cuando alcanzas el límite de tu plan (consultas, análisis de expedientes o transcripciones), IUSPRO te mostrará
automáticamente las opciones disponibles.

## Si ya tienes una suscripción activa

- Se abrirá un modal con **paquetes adicionales** disponibles
- Puedes comprar paquetes de:
  - **Consultas adicionales** para Auri
  - **Expedientes adicionales** para análisis
- Simplemente selecciona el paquete que necesitas y completa el pago

## Si no tienes suscripción

- Se te mostrará el modal de **planes de suscripción**
- Selecciona el plan que mejor se adapte a tus necesidades
- Completa el proceso de pago para activar tu plan

## Comprar desde Facturación

También puedes ver y cambiar tu plan en cualquier momento:

1. Haz clic en tu **nombre o email** en la esquina inferior izquierda
2. Selecciona **"Preferencias"**
3. Ve a la pestaña **"Facturación"**

Desde ahí verás:

- Tu plan actual y sus límites
- Opciones para cambiar a un plan superior o inferior
- El precio y fecha del próximo cobro
